import { icons } from '@/Icons';
import React from 'react';
import ds from '@/styles/ds/ds.module.scss';

const OpenCloseArrow = ({ open }) => {
	return (
		<div
			className={`${ds.button} ${ds.tertiary} !w-6 !h-5 !px-1 !py-1.5 !shadow-none !rounded-[4px]
				group-hover:!border-electric-sky`}
		>
			<icons.accordionarrow
				className={`w-3 h-3 ${open ? 'rotate-180' : ''} transition-all duration-200 ease-in-out`}
			/>
		</div>
	);
};

export default OpenCloseArrow;
